module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"loading":"Загрузка данных...","date_required":"Укажите дату","departure_station_required":"Выберите станцию отправления","arrival_station_required":"Выберите станцию назначения"},"uz":{"loading":"Maʼlumotlar yuklanmoqda...","date_required":"Sanasini koʼrsating","departure_station_required":"Выберите станцию отправления","arrival_station_required":"Выберите станцию назначения"}}')
  delete Component.options._Ctor
}
